module.exports = {
  forms:[
    {
      n_id:1,
      group1:true,
      id:"sending_and_receiving_slips",
      label:"送付授受票",
      print_rule:"T0001"
      // Later add file name here
    },
    {
      n_id:2,
      group1:true,
      id:"collection_and_receipt_slips",
      label:"回収授受票",
      print_rule:"T0002",
      alternatives:{
        page1:"T0002",
        page4:"T0003"
      }
    },
    {
      n_id:3,
      group1:true,
      id:"return_delivery_form",
      label:"返却授受票",
      // disabled:false,
      print_rule:"T0003"
    },
    {
      n_id:4,
      group1:true,
      id:"distribution_check_list",
      label:"配布チェックリスト",
      disabled:false,
      print_rule:"T0004A",
      alternatives:{
        page1:"T0004B",
        page4:"T0004A",
        page1_paper:"T0004Bp"
      }
    },
    {
      n_id:15,
      group1:true,
      id:"return_check_list",
      label:"返却チェックリスト",
      disabled:false,
      print_rule:"T0024A",
      alternatives:{
        page1:"T0024B",
        page4:"T0024A",
        // page1_paper:"T0024Bp" // Not implemented
      }
    },

    {
      n_id:5,
      group1:true,
      id:"tablet_terminal_apple_id_password_management_slip",
      label:"タブレット端末 AppleIDパスワード管理表",
      disabled:false,
      print_rule:"T0005A",
      alternatives:{
        page1:"T0005B",
        page2:"T0005A"
      }
    },
    {
      n_id:6,
      group1:true,
      id:"registered_shipping_and_receiving_book",
      label:"書留発送簿兼授受簿",
      disabled:false,
      print_rule:"T0006A",
      alternatives:{
        page1:"T0006B",
        page4:"T0006A"
      }
    },
    {
      n_id:7,
      group1:true,
      id:"label_8_pieces",
      label:"ラベル 8面",
      disabled:false,
      require_position_selection:true,
      positions:{r:4,c:2},
      print_rule:"T0007",
      alternatives:{
        page1:"T0007B",
        page4:"T0007A"
      }
    },
    {
      n_id:8,
      group1:true,
      id:"label_36_pieces",
      label:"ラベル 36面",
      disabled:false,
      require_position_selection:true,
      positions:{r:12,c:3},
      print_rule:"T0008",
      alternatives:{
        page1:"T0008B",
        page4:"T0008A"
      }
    },  {
      n_id:11,
      id:"enroll",
      label:"エンロール削除",
      disabled:false,
      print_rule:"T0011"
    },  {
      n_id:12,
      id:"revocation_correspondence",
      label:"リボーク対応",
      disabled:false,
      print_rule:"T0012"
    }, {
      n_id:13,
      id:"pass_unlock",
      label:"パスコード解除",
      disabled:false,
      print_rule:"T0013"
    }, {
      n_id:14,
      id:"tablet_device_information_sheet",
      label:"タブレット端末情報シート",
      disabled:false,
      print_rule:"T0014"
    },
    {
      n_id:15,
      id:"cancellation_checklist_sheet",
      label:"解約チェックリスト",
      disabled:false,
      print_rule:"T0025"
    }
  ],
}


// WEBPACK FOOTER //
// ./src/rules/output_config.js